<template>
  <div id="searchEngineD" class="listStyle">
    <div id="goToHere2"></div>
    <!-- 法规分类 -->
    <classification-rules
      ref="classification"
      @showGetData="showGetData"
      @changeTagid="changeTagid"
      @getTree="getTree"
      :classifyresult="classifyresult"
      :classifytag="data"
      :stime="stime"
      :etime="etime"
      :searchText="searchText"
    ></classification-rules>
    <!-- 法规层级 -->
    <regulations-hierarchy
      ref="regulations"
      @getSearchLists="getSearchLists"
    ></regulations-hierarchy>

    <!-- 搜索框 -->
    <!-- :newSearchText="newSearchText" -->
    <SearchBox
      v-show="flag"
      ref="searchBox"
      @searchKeyWord="searchKeyWord"
      @selectTime="selectTime"
      @clearTime="clearTime"
      @changePotence="changePotence"
      @chooseType="chooseType"
    ></SearchBox>

    <!-- 一键上传 -->
    <upload-file ref="uploadFile"></upload-file>

    <!-- 搜索导航 -->
    <div
      v-if="classifyresult.length && lists.length !== '' && currentType == 1"
      class="classify-nav-box"
    >
      <div
        v-for="(item, index) in classifyresult"
        :key="index"
        class="classify-nav-item"
      >
        <span class="classify-nav-content">
          {{ item }}
        </span>
        <!-- <span class="sanjiao"></span> -->
      </div>
    </div>
    <!-- 列表组件 -->
    <list-content
      ref="listContent"
      :lists="lists"
      :total="total"
      :searchBG="searchBG"
    ></list-content>
    <div style="height: 1.9rem"></div>
    <!-- 分页 -->
    <div v-if="lists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :totalLists="totalLists"
        @prevPage="prevPage"
        @nextPage="nextPage"
        @jumpToPageSize="jumpToPageSize"
      ></Pagination>
    </div>
    <!-- 底部导航 -->
    <tabbar
      ref="tabbar"
      :upSuccess="upSuccess"
      :currentType="currentType"
      @alertBars="alertBars"
      @alertCengji="alertCengji"
      @updateOrDelete="updateOrDelete"
      @chooseUpdateOrDelete="chooseUpdateOrDelete"
      :selectedID="selectedId"
    ></tabbar>

    <van-overlay :showLoding="showLoding"></van-overlay>
  </div>
</template>

<script>
import SearchBox from "@/components/common/search";
import Tabbar from "@/components/common/tabbar";
import ClassificationRules from "@/components/common/classificationRules"; // 法规分类
import RegulationsHierarchy from "@/components/common/regulationsHierarchy"; // 法规层级
import UploadFile from "@/components/common/uploadFile"; // 一键上传
import ListContent from "@/components/common/listContent";
import VanOverlay from "@/components/common/vanOverlay";
import Pagination from "@/components/common/pagination"; // 分页
import searchEnginePop from "@/components/newcommon/searchEnginePop";
import { commonToast } from "@/utils/lib/toast.js";

import { sortclassify } from "@/utils/newLibs/sortclassify";
import { commonNotify, warningNotify } from "../../utils/lib/toast";
const bgc = require("../../assets/index/searchbg.png");
export default {
  data() {
    return {
      searchBG: bgc,
      // 进度条
      showLoding: false,

      selectedId: "b",
      data: {
        classifytag: [],
        minlock: 0,
      },
      minback: 0,
      minlock: 0,
      classifytag: [],
      stime: "",
      etime: "",
      searchText: "",

      flag: true,
      lists: [],
      total: 0,

      totalLists: 0, // 总的条数

      // 查询次数
      SearchTimes: 1,

      // 文件效力
      value1: "",
      option1: [
        { text: "请选择", value: "" },
        { text: "所有效力", value: "1" },
        { text: "全文有效", value: "20" },
        { text: "尚未生效", value: "0" },
        { text: "部分废止(失效)", value: "30" },
        { text: "全文废止(失效)", value: "40" },
      ],

      tagid: "",
      isFilter: false,

      currentPage: 1,

      tagpc: [],
      changedtagpc: [],
      t1: [],
      t2: [],
      t3: [],
      classifyresult: [],
      cenjiFlag: false,
      currentType: 1,
      potence: '',
      upSuccess: false //上传成功标志
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },

    changeFlag() {
      // 切换全国版 true 与地方版 false
      return this.$store.state.changeVersion.changeFlag;
    },
    // newSearchText() {
    //   // 切换全国版 true 与地方版 false
    //   return this.$store.state.changeSomeThing.newSearchText;
    // },
  },
  components: {
    SearchBox,
    Tabbar,
    ClassificationRules,
    RegulationsHierarchy,
    UploadFile,
    ListContent,
    VanOverlay,
    Pagination,
    searchEnginePop,
  },
  created() {
    // console.log(this.newSearchText);
    // this.initTree();
  },
  methods: {
    chooseType (e) {
      this.$refs.listContent.setCurrentType(e);
      this.lists = []
      this.currentType = e
      if(this.potence != '1' && this.potence) {
        this.potence = '1'
      }
      if (e == 1) {
        this.classifyresult = []
        this.$refs.classification.clearTagId()
      } else {
        this.isFilter = false
      }
      // if (e== 1 && this.potence) {
      //   this.$refs.searchBox.changePotence("1")
      // }
      console.log("###", e)
      this.getData()
    },
    // 获取检索的数据
    getData() {
      this.showLoding = true;
      let argsAnswer = {
        searchtimes: this.SearchTimes,
        frist: {
          text: this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: this.potence,
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode
          },
          dirid: "",
          id: "",
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : ""
        },
        second: [],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.isFilter ? this.changedtagpc : [],
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 每页显示的条数
            pageindex: this.currentPage, // 当前页
          },
        ],
        scencs: "answer"
      };
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text:
            this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: this.potence, // 文件效力
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: this.tagid && this.tagid !== "" ? this.tagid : "",
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : "",
        },
        second: [],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.isFilter ? this.changedtagpc : [],
          tagid: this.isFilter ? this.tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 每页显示的条数
            pageindex: this.currentPage, // 当前页
          },
        ]
      };
      //console.log("综合检索地方的数据====》", args);
      let nodes = this.$baseConfig.code;
      this.updateDatas = args;

      if (this.currentType == 1) {
        this.$http
        .reqGetGeneralFiles(args, nodes)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              console.log("111111====》", response);
              this.showLoding = false;

              this.lists =
                response.tbls[0].items !== null ? response.tbls[0].items : [];

              this.t1 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t1.length > 0
                  ? response.tbls[0].divisiontag.t1
                  : [];
              this.t2 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t2.length > 0
                  ? response.tbls[0].divisiontag.t2
                  : [];
              this.t3 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t3.length > 0
                  ? response.tbls[0].divisiontag.t3
                  : [];

              this.t2 = this.t2.sort((a, b) => a.id - b.id);
              this.t3 = this.t3.sort((a, b) => a.id - b.id);

              this.proAndCityData = {
                t1: this.t1.length > 0 ? this.t1 : [],
                t2: this.t2.length > 0 ? this.t2 : [],
                t3: this.t3.length > 0 ? this.t3 : [],
              };

              this.tagpc = this.filterData(this.proAndCityData);
              this.cenjiFlag = true;
              this.total = Math.ceil(response.tbls[0].total / 10);
              this.totalLists = response.tbls[0].total; // 总的条数

              this.$store.commit(
                "search/setIsProtect",
                response.tbls[0].protect
              );
              this.$store.commit(
                "search/setWarningLevel",
                response.tbls[0].warninglevel
              );
              this.$store.commit(
                "search/setWarningText",
                response.tbls[0].warningtext
              );
              this.$store.dispatch("choose/updateLists", this.lists);

              // this.bus.$emit("classifytagData", this.data);
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch((err) => {
          this.showLoding = false;
        });
      } else {
        this.$http
        .reqGetGeneralFiles(argsAnswer, nodes)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              console.log("222222====》", response);
              this.showLoding = false;

              this.lists =
                response.tbls[0].items !== null ? response.tbls[0].items : [];

              this.t1 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t1.length > 0
                  ? response.tbls[0].divisiontag.t1
                  : [];
              this.t2 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t2.length > 0
                  ? response.tbls[0].divisiontag.t2
                  : [];
              this.t3 =
                response.tbls[0].divisiontag.length !== 0 &&
                response.tbls[0].divisiontag.t3.length > 0
                  ? response.tbls[0].divisiontag.t3
                  : [];

              this.t2 = this.t2.sort((a, b) => a.id - b.id);
              this.t3 = this.t3.sort((a, b) => a.id - b.id);

              this.proAndCityData = {
                t1: this.t1.length > 0 ? this.t1 : [],
                t2: this.t2.length > 0 ? this.t2 : [],
                t3: this.t3.length > 0 ? this.t3 : [],
              };

              this.tagpc = this.filterData(this.proAndCityData);
              this.cenjiFlag = true;
              this.total = Math.ceil(response.tbls[0].total / 10);
              this.totalLists = response.tbls[0].total; // 总的条数

              this.$store.commit(
                "search/setIsProtect",
                response.tbls[0].protect
              );
              this.$store.commit(
                "search/setWarningLevel",
                response.tbls[0].warninglevel
              );
              this.$store.commit(
                "search/setWarningText",
                response.tbls[0].warningtext
              );
              this.$store.dispatch("choose/updateLists", this.lists);

              // this.bus.$emit("classifytagData", this.data);
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch((err) => {
          this.showLoding = false;
        });
      }

  
    },

    getTree(data) {
      console.log("getTree START");
      //this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: data.searchText !== undefined ? data.searchText : "",
          potence: "1",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: data.tagid !== undefined ? data.tagid : "",
          stime: "",
          etime: "",
        },
        second: [],
        fliter: {
          isfilter: false,
          tagpc: [],
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage, // 每页显示的条数
          },
        ],
      };
      console.log("argsargsparams666666666666", args);
      this.$http
        .reqGetGeneralFiles(args)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              console.log("获取云端文件==============>>>>>", response);
              if (
                response.tbls[0].items === null &&
                response.tbls[0].classifytag.length === 0
              ) {
                this.$refs.classification.alertBar2();
              }

              this.showLoding = false;
              if (response.tbls[0].classifytag.length !== 0) {
                this.classifytag = response.tbls[0].classifytag;
                this.minback = response.tbls[0].minback;
                this.minlock = response.tbls[0].minlock;
                this.flag = true;
                this.data = {
                  classifytag: this.classifytag,
                  minlock: this.minlock ? this.minlock : 0,
                };
              }

              this.bus.$emit("classifytagData", this.data);
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 第一次改变tagid的时候 循环城市数据 tagpc
    filterData(data) {
      let searchParameter = [];
      let national = [];
      let tagpc1 = [];
      let tagpc2 = [];
      if (data.t1.length > 0) {
        national = [{ p: "000000", c: "000000" }];
      }
      if (data.t2.length > 0) {
        // 循环省份
        data.t2.forEach((item) => {
          let stringlength = item.id.length;
          let pstring = item.id.substring(0, 6); // 截取前六位
          let nstring = item.id.substring(stringlength - 6, stringlength); // 截取后六位
          tagpc1.push({ p: pstring, c: nstring });
        });
      }
      if (data.t3.length > 0) {
        // 循环城市
        data.t3.forEach((item) => {
          if (item.children && item.children.length > 0) {
            item.children.forEach((item1) => {
              let stringlength = item1.id.length;
              let pstring = item1.id.substring(0, 6); // 截取前六位
              let nstring = item1.id.substring(stringlength - 6, stringlength); // 截取后六位
              tagpc2.push({ p: pstring, c: nstring });
            });
          }
        });
      }
      searchParameter = [...national, ...tagpc1, ...tagpc2];
      return searchParameter.length > 0 ? searchParameter : this.tagpc;
    },
    alertBars() {
      this.$refs.classification.alertBars();
    },
    alertCengji() {
      this.$refs.regulations.alertCengji();
      if (this.cenjiFlag === true) {
        this.$refs.regulations.processData(this.proAndCityData);
      }
    },

    // 选择省份城市后触发的事件
    getSearchLists(tagpc) {
      console.log("传递给父组件的数据tagpc==》", tagpc);
      // console.log('传递给父组件的数据this.showAllTagpc==》', this.showAllTagpc)
      // this.clickConfirmBtn = false;
      this.isFilter = true;
      this.changedtagpc = tagpc;
      console.log("this.tagpc", this.tagpc);
      this.currentPage = 1;
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },

    updateOrDelete() {
      let activePlace = this.$store.state.commonSearchData.activePlace;
      if (this.userId) {
        this.$refs.uploadFile.updateOrDelete(this.updateDatas, "综合检索");
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
          duration: 5000,
        });
      }
    },
    chooseUpdateOrDelete() {
      if (this.userId) {
        if (
          this.$store.state.choose.flag1 === false &&
          this.lists.length > 0 &&
          this.$store.state.choose.result.length === 0
        ) {
          this.$refs.listContent.changeFlag();
          this.$store.commit("choose/setFlag1", true);
          this.$store.commit("choose/setChooseUp1", "确定");
          this.$notify({
            color: "#fff",
            background: "#F27852",
            message: "请先选择要上传的文件",
            duration: 3000,
          });
        } 
          else if (
          this.$store.state.choose.flag1 === true &&
          this.lists.length > 0 &&
          this.$store.state.choose.result.length === 0
        ) {
          this.backStatus();
          this.clearResult();
        } else if (
          this.$store.state.choose.flag1 === true &&
          this.lists.length > 0 &&
          this.$store.state.choose.result.length > 0
        ) {
          this.$refs.uploadFile.updateOrDelete(
            this.$store.state.choose.result,
            "选择上传"
          );
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
        });
      }
    },
    clearResult() {
      this.$refs.listContent.toggle([]);
    },

    showGetData(data) {
      this.SearchTimes = 1;
      this.tagid = data.tagid;
      this.stime = data.stime;
      this.etime = data.etime;
      this.searchText = data.searchText;

      this.isFilter = false;

      this.getData();
    },

    changeTagid(val) {
      //console.log('abcdefg', val)
      this.tagid = val;
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    clearProOrCityMsg() {
      this.currentPage = 1;
    },

    // 恢复选择的状态
    backStatus() {
      this.$refs.listContent.changeFlag2();
      this.$store.commit("choose/setFlag1", false);
      this.$store.commit("choose/setChooseUp1", "选择上传");
      this.$store.commit("choose/setResult", []);
      this.upSuccess = true
    },
    searchKeyWord(keyword) {
      this.searchText = keyword;

      this.SearchTimes = 1;

      this.isFilter = false;

      this.currentPage = 1;
      if (this.value1) {
        this.potence = this.value1
      } else {
        this.potence = "1"
      }
      this.$refs.listContent.toggle([]);
      
      this.getData();
    },
    selectTime(time) {
      this.stime = time.stime;
      this.etime = time.etime;
      this.currentPage = 1;
      this.isFilter = false;

      this.SearchTimes = 1;

      this.$refs.listContent.toggle([]);
      this.getData();
    },
    clearTime() {
      this.SearchTimes = 1;

      this.currentPage = 1;

      this.stime = "";
      this.etime = "";

      this.$refs.listContent.toggle([]);
      this.getData();
    },

    prevPage() {
      // 上一页
      if (this.currentPage == 1) return;
      this.currentPage--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
    nextPage() {
      // 下一页
      if (this.currentPage == this.total) return;
      this.currentPage++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
    jumpToPageSize(num) {
      // 跳转到多少页
      this.currentPage = num;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
    // 改变树的参数
    changePotence(val) {
      // this.$refs.classification.changeSearchNav1("0");
      console.log("改变文件效力====", val);
      this.currentPage = 1;
      this.SearchTimes = 1;
      this.isFilter = false;
      this.value1 = val;
      this.potence = this.value1
      this.getData();
    },
  },
  watch: {
    classifytag(newval, oldval) {
      console.log(newval, oldval);
      this.classifyresult = [];
      if (this.minlock !== 0 && this.minlock !== undefined) {
        sortclassify(newval, this.classifyresult, this.minlock);
      }
      // console.log(this.classifyresult);
    },
  },
};
</script>

<style lang="less" scope>
#searchEngineD {
  display: flex;
  flex-direction: column;
  .top {
    flex: 1;
    margin-bottom: 70px;
  }
  .selectNavS {
    padding: 20px 20px 150px;
  }
  .timeBox {
    height: 45px;
    display: flex;
    margin: 0 0 2px 0;
    padding: 0 8px 0 15px;
    .time {
      flex: 1;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 8px;
    }
  }
  .searchItem {
    display: flex;
    .name {
      line-height: 52px;
      flex: 0 0 70px;
      text-align: center;
      color: #333;
    }
    .content {
      flex: 1;
    }
  }
  .btn {
    text-align: center;
    margin-top: 20px;
  }
}
.classify-nav-box {
  display: flex;
  padding: 0 6px;
  overflow-x: scroll;
  overflow-y: hidden;
  background-color: #fff;

  // margin-bottom: 2px;
  .classify-nav-item {
    display: flex;
    align-items: center;
    .classify-nav-content {
      display: flex;
      padding: 0 0 0 6px;
      white-space: nowrap;
      height: 24px;
      font-size: 12px;
      color: #cb9728;
      line-height: 24px;
      background-color: #fff;
      &::after {
        margin-left: 4px;
        content: ">";
        color: #666;
      }
    }
    &:last-child {
      .classify-nav-content {
        &::after {
          content: "";
        }
      }
    }
    .sanjiao {
      margin-right: 4px;
      border-top: 10px solid transparent;
      border-left: 10px solid #fff;
      border-bottom: 10px solid transparent;
      filter: drop-shadow(2px 2px 10px rgba(0, 0, 0, 0.1));
    }
  }
}
</style>
